var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import styles from './historyItem.module.scss';
import { COLORS } from 'src/shared/styles/colors';
import { HistoryItems } from './HistoryItems';
export var HistoryItem = function (props) {
    var i18n = props.i18n, dateOfEvent = props.dateOfEvent, eventType = props.eventType, color = props.color, label = props.label, applicants = props.applicants, host = props.host;
    var Item = HistoryItems(eventType, host);
    return (_jsxs("li", __assign({ className: styles.historyItemWrapper }, { children: [_jsx("span", __assign({ className: styles.historyItemTime }, { children: dateOfEvent.toLocaleString(DateTime.TIME_24_SIMPLE) })), _jsxs("div", __assign({ className: styles.historyContent, style: { background: "linear-gradient(to right, ".concat(color, " 8px, ").concat(COLORS.WHITE, " 8px)") } }, { children: [_jsx("p", __assign({ className: styles.historyLabel, style: { color: color } }, { children: label })), _jsx("span", { className: styles.separator, style: { backgroundColor: color } }), _jsx("div", __assign({ className: styles.historyDescriptionsWrapper }, { children: Item && _jsx(Item, __assign({ i18n: i18n, applicants: applicants }, props)) }))] }))] })));
};
